import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import BusinessOperatingStatusProxy from './proxy'

class BusinessOperatingStatusService extends ServiceBase {
  getBusinessOperatingStatusTable(params) {
    return this.getData(() =>
      BusinessOperatingStatusProxy.getBusinessOperatingStatusTable(params),
    )
  }
  exportBusinessOperatingStatus(params) {
    return this.getFileDownload(() =>
      BusinessOperatingStatusProxy.exportBusinessOperatingStatus(params),
    )
  }
}

export default new BusinessOperatingStatusService()
